import { ApiResponseType, BaseResponseType } from '@/types/sharedTypes';
import { authApiService } from '@/api/authApiService';

export const reinviteRecipientByProxyApi = (wireId: string): Promise<ApiResponseType<BaseResponseType>> => {
  const uri = `/recipient/wires/${wireId}/recipient/reinvite/`;

  return authApiService.POST(uri, {});
};
